import { ProjectLoader } from '../services/ProjectLoader';
import { JokaRootStore } from './JokaRootStore';
import { LoadedProjectStore } from './LoadedProjectStore';

export const rootStore = new JokaRootStore();
const projectLoader = new ProjectLoader(rootStore.localization);
export const loadedProjectStore = new LoadedProjectStore(projectLoader);
